<div class="container py-5">
  <h1 class="fw-bold mb-4 placeholder-glow">
    @if (event) {
      {{ event.title }}
    } @else {
      <span class="placeholder col-4"></span>
    }
  </h1>

  <div class="row g-4">
    <div class="col-md-5">
      <img
        [src]="event?.image_url || '/assets/img/placeholder.png'"
        class="img-fluid rounded shadow-sm mb-3"
        alt="Imagen del evento"
      />

      <p class="text-muted mb-0 placeholder-glow">
        @if (event) {
          <i class="bi bi-cursor-fill me-1"></i>
          <strong>{{ event.date | date: 'MMMM d, y' }}</strong>
          <br />
          <small>
            {{ event.time }} -
            {{ event.time }}
          </small>
        } @else {
          <span class="placeholder col-5"></span>
          <br />
          <span class="placeholder col-4"></span>
        }
      </p>
    </div>

    <div class="col-md-7">
      <div class="border rounded p-3">
        <h5 class="border-bottom pb-2">Sobre el evento</h5>

        <p class="placeholder-glow">
          @if (event) {
            {{ event.description }}
          } @else {
            <span class="placeholder col-6"></span>
          }
        </p>

        <h5 class="border-bottom pt-3 pb-2">Ubicación</h5>
        <p class="mb-1 placeholder-glow">
          @if (event) {
            <i class="bi bi-cursor-fill me-1"></i>
            <strong>{{ event.address }}</strong>
            <br />
            {{ event.address }}
          } @else {
            <span class="placeholder col-6"></span>
            <br />
            <span class="placeholder col-4"></span>
          }
        </p>
        <p class="mb-2 placeholder-glow">
          @if (event) {
            <strong>{{ event.address }}</strong>
            <br />
            {{ event.address }}
          } @else {
            <span class="placeholder col-6"></span>
            <br />
            <span class="placeholder col-4"></span>
          }
        </p>

        <div class="ratio ratio-16x9 mb-3">
          @if (mapSrc) {
            <iframe
              [src]="mapSrc"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          }
        </div>

        <h5 class="border-bottom pt-3 pb-2">Información extra</h5>
        <p class="mb-0 placeholder-glow">
          @if (event) {
            <i class="bi bi-play-fill me-1"></i>
            {{ event.address }}
          } @else {
            <span class="placeholder col-6"></span>
          }
        </p>
      </div>
    </div>
  </div>
</div>
